import config from "../_config/config";
import { authHeader } from "../_helpers";
import axios from "axios";

axios.defaults.baseURL = config.apiUrl;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.put["Content-Type"] = "application/json";
axios.defaults.headers.put["X-Requested-With"] = "XMLHttpRequest";

export const timelineService = {
  getPatientTimeline,
};

function getPatientTimeline(hash, filters = {}) {
  var sett = { headers: authHeader(), params: filters };
  return axios
    .get("aisp/patient/" + hash + "/timeline", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}
